module.exports = __webpack_public_path__ + "static/bag_of_tricks-3234d067d21513e7cfc6298c4a1cc5da.jpeg";